// extracted by mini-css-extract-plugin
export default {"main":"CriteriaList_main__FLj8q","criteriaType":"CriteriaList_criteriaType__CFPKA"};